import { Icon } from '@iconify/react';

const IconifyIcon = (props) => <Icon {...props} />;

export default IconifyIcon;
